import { Component, ElementRef, EventEmitter, HostListener, Input, Output, ViewChild, ChangeDetectorRef,  OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { NotificationService } from '../services/notification.service';
import { CreateProjectService } from '../services/create-project.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { finalize } from 'rxjs/operators';
import * as ExcelJS from 'exceljs';
import { RoleViewService } from '../services/role-view.service';
@Component({
  selector: 'app-select-collection',
  standalone: true,
  imports: [CommonModule, FormsModule, MatIconModule, MatTooltipModule],
  templateUrl: './select-collection.component.html',
  styleUrl: './select-collection.component.css',

})

export class SelectCollectionComponent implements OnInit {
  private readonly COLLECTION_NAME_REQUIRED = 'Collection name is required';

  showAddModal = false;
  newCollectionName = '';
  newSubCollectionName = '';
  selectedCollectionIndex: number | null = null
  isInvalid = false;
  isSmallScreen= false;
  @Output() isButtonEnabled: EventEmitter<Object> = new EventEmitter();
  @Input() collectionId: any;
  @Input() subCollectionIds: any;
  subCollectionArray = [{ value: '' }];
  selectedTabIndex = 0;
  newSubCollections: string[] = [''];
  isFormValid = false;
  collectionExists = false;
  subCollectionExists: boolean[] = [];
  isLoading = false;
  collections: any[] = [];  // Store the fetched collections
  filteredCollections: any[] = [];
  filteredSubCollections: any[] = [];
  selectedCollection: any = null;
  selectedSubCollections: any[] = [];
  searchTermCollections = '';
  searchTermSubCollections = '';
  // dialog-local search state so popup typing doesn't overwrite main search
  dialogSearchTerm = '';
  filteredCollectionsDialog: any[] = [];
  sortDirection: 'asc' | 'desc' | '' = '';
  sortDirectionSubCollection: 'asc' | 'desc' | '' = '';
  scrHeight = '';
  userRole = '';
  isChecked = false;
  isSubChecked = false;
  workDayId: any
  @ViewChild('dynamicDiv', { static: false }) dynamicDiv!: ElementRef;
  // dynamicHeight: any = '328vh';
  dialogRef: any;
  userName: any;


  constructor(private readonly notificationService: NotificationService,private readonly roleviewService: RoleViewService,
     private readonly createProjectService: CreateProjectService, private readonly spinner: NgxSpinnerService, private readonly cdr: ChangeDetectorRef) {
    // Defer screen size calculations to ngOnInit for better performance
  }

  ngOnInit(): void {
     this.workDayId = this.createProjectService.getWorkdayId();
     this.userRole = this.roleviewService.getAdminAsRole();
     this.userName = this.roleviewService.getUserName();
    // Initialize screen size
    this.getScreenSize();
    this.updateScreenSize();
    this.fetchCollectionDetails();
    // Load saved selection first (instant)
    const getSelectedDetails = this.createProjectService.getSelectedCollection();
    if (getSelectedDetails) {
      this.selectedCollection = getSelectedDetails;
      this.filteredSubCollections = this.selectedCollection.sub_collections || [];
      this.isChecked = true;
      this.isSubChecked = true;
    }
  }

  fetchCollectionDetails() {
    this.createProjectService.fetchCollections(this.workDayId)
      .pipe(finalize(() => {
        this.cdr.detectChanges();
      }))
      .subscribe(
        (data) => {
          console.info("response", data.payload.response);
          // Process and sort in one pass for better performance
          this.collections = data.payload.response
            .map((collection: any) => ({
              ...collection,
              isFavorite: collection.is_favorite || false
            }))
            .sort((a: any, b: any) => (b.isFavorite ? 1 : 0) - (a.isFavorite ? 1 : 0));

          // Use direct assignment instead of spread for initial load
          this.filteredCollections = this.collections;
          this.filteredCollectionsDialog = this.collections;
          const selectedFromApi = this.createProjectService.getSelectedSubCollection();
          if (!selectedFromApi || selectedFromApi.length === 0) {
            this.collectionSetFromApi();
          }

        }
      );
  }

  collectionSetFromApi() {
    if (this.collectionId) {
       const preSelected = this.collections.find(c => c.collection_id === Number(this.collectionId));
      if (preSelected) {
        this.selectCollection(preSelected);
      }
    }
    if (this.subCollectionIds) {
      this.filteredSubCollections.forEach(sub => {
        if (this.subCollectionIds.includes(sub.sub_collection_id.toString())) {
          this.toggleSubCollectionSelection(sub);
        }
      });
    }
  }

  @HostListener('window:resize', ['$event'])
  getScreenSize(_event?: Event) {
    this.scrHeight = `${window.innerHeight - 250}px`;
  }

  onResize(_event: Event) {
    this.updateScreenSize();
  }

  updateScreenSize() {
    const width = window.innerWidth;
    this.isSmallScreen = width >= 350 && width <= 766;
  }


  filterCollections() {
    const searchTermNormalized = this.searchTermCollections.trim().toLowerCase();

    if (searchTermNormalized) {
      // Filter collections based on collection_name and collection_id
      this.filteredCollections = this.collections.filter(c =>
        c.collection_name.toLowerCase().includes(searchTermNormalized) ||
        c.collection_id.toString().includes(searchTermNormalized)
      );
    } else {
      // Direct assignment is faster than spread for resetting
      this.filteredCollections = this.collections;
    }
  }

  // Filter function for sub-collections
  filterSubCollections() {
    const searchTermNormalized = this.searchTermSubCollections.trim().toLowerCase();

    if (searchTermNormalized) {
      // Filter sub-collections based on sub_collection_name and sub_collection_id
      this.filteredSubCollections = (this.selectedCollection?.sub_collections || []).filter((c: any) =>
        c.sub_collection_name.toLowerCase().includes(searchTermNormalized) ||
        c.sub_collection_id.toString().includes(searchTermNormalized)
      );
    } else {
      // Direct assignment for better performance
      this.filteredSubCollections = this.selectedCollection?.sub_collections || [];
    }
  }


  filterCollectionsDialog() {
    const searchTermNormalized = this.dialogSearchTerm.trim().toLowerCase();

    if (searchTermNormalized) {
      this.filteredCollectionsDialog = this.collections.filter(c =>
        c.collection_name.toLowerCase().includes(searchTermNormalized) ||
        c.collection_id.toString().includes(searchTermNormalized)
      );
    } else {
      this.filteredCollectionsDialog = this.collections;
    }
  }

  private showToast(msg: string) {
    this.notificationService.showSuccess(msg);
  }

  savetheCollection(collectionName: string) {
    const payload = { collectionName: collectionName.trim(), createdBy: this.userName };
    if (!payload.collectionName) {
      this.showToast(this.COLLECTION_NAME_REQUIRED);
      return;
    }

    this.isLoading = true;
    this.createProjectService.saveCollections(payload)
      .pipe(finalize(() => (this.isLoading = false)))
      .subscribe({
        next: (res) => {
          this.showToast(res?.message || 'Collection saved');
          this.resetForm();
          this.fetchCollectionDetails();
          this.showAddModal = false;
        },
        error: () => this.showToast('Failed to save collection')
      });
  }

  savetheCollectionWithSubCollections(collectionName: string, subs: string[]) {
    const cleanedSubs = (subs || []).map(s => (s || '').trim()).filter(Boolean);
    const payload = { collectionName: collectionName.trim(), subCollections: cleanedSubs, createdBy: this.userName };
    if (!payload.collectionName) {
      this.showToast(this.COLLECTION_NAME_REQUIRED);
      return;
    }
    if (!payload.subCollections.length) {
      this.showToast('Add at least one sub-collection');
      return;
    }

    this.isLoading = true;
    this.createProjectService.saveCollectionWithSubCollections(payload)
      .pipe(finalize(() => (this.isLoading = false)))
      .subscribe({
        next: (res) => {
          this.showToast(res?.message || 'Collection + sub-collections saved');
          this.resetForm();
          this.fetchCollectionDetails();
          this.showAddModal = false;
        },
        error: () => this.showToast('Failed to save collection + sub-collections')
      });
  }


  savetheSubCollection(collectionId: number, subs: string[]) {
    const cleanedSubs = (subs || []).map(s => (s || '').trim()).filter(Boolean);
    const payload = { collectionId, subCollectionName: cleanedSubs, createdBy: this.userName };
    if (!payload.collectionId) {
      this.showToast('Select a collection');
      return;
    }
    if (!payload.subCollectionName.length) {
      this.showToast('Enter at least one sub-collection');
      return;
    }

    this.isLoading = true;
    this.createProjectService.saveSubCollections(payload)
      .pipe(finalize(() => (this.isLoading = false)))
      .subscribe({
        next: (res) => {
          this.showToast(res?.message || 'Sub-collections added');

          // Optimistically update the selected collection's sub_collections so
          // the new sub-collections appear immediately without a page refresh.
          const addedSubs = (payload.subCollectionName || []).map((name: string, idx: number) => ({
            sub_collection_id: Date.now() + idx,
            sub_collection_name: name
          }));

          // Update selectedCollection in-place
          if (this.selectedCollection) {
            this.selectedCollection.sub_collections = [
              ...(this.selectedCollection.sub_collections || []),
              ...addedSubs
            ];
            // Update filteredSubCollections to reflect changes in UI
            this.filteredSubCollections = [...this.selectedCollection.sub_collections];

            // Also update the master collections array so list reflects new data
            this.collections = (this.collections || []).map(c =>
              c.collection_id === payload.collectionId ? this.selectedCollection : c
            );
            this.filteredCollections = [...this.collections];
          }

          this.showAddModal = false;
        },
        error: () => this.showToast('Failed to add sub-collections')
      });
  }


  saveSubCollection(tabIndex: number) {
    const name = (this.newCollectionName || '').trim();

    // Tab 0 (Add Collection) sub inputs come from subCollectionArray[i].value
    const subsTab0 = (this.subCollectionArray || [])
      .map((s: any) => (s?.value || '').trim())
      .filter((s: string) => !!s);

    // Tab 1 (Add Sub Collection) inputs come from newSubCollections[i]
    const subsTab1 = (this.newSubCollections || [])
      .map((s: string) => (s || '').trim())
      .filter((s: string) => !!s);

    if (tabIndex === 0) {
      if (!name) {
        this.showToast(this.COLLECTION_NAME_REQUIRED);
        return;
      }
      if (subsTab0.length > 0) {
        this.savetheCollectionWithSubCollections(name, subsTab0);
      } else {
        this.savetheCollection(name);
      }
    } else if (tabIndex === 1) {
      if (!this.selectedCollection?.collection_id) {
        this.showToast('Select a collection');
        return;
      }
      this.savetheSubCollection(this.selectedCollection.collection_id, subsTab1);
    }
  }

  validateCollectionName() {
    const newName = this.newCollectionName?.trim().toLowerCase();
    if (!newName) {
      this.collectionExists = false;
      return;
    }
    // check duplicates
    this.collectionExists = this.collections.some(
      (c: any) => c.collection_name?.trim().toLowerCase() === newName
    );
  }

  validateSubCollectionName(index: number) {
    const newName = this.newSubCollections[index]?.trim().toLowerCase();
    if (!newName) {
      this.subCollectionExists[index] = false;
      return;
    }

    const existingNames = this.selectedCollection?.sub_collections?.map(
      (sc: any) => sc.sub_collection_name.trim().toLowerCase()
    ) || [];

    this.subCollectionExists[index] = existingNames.includes(newName);
  }

  onTabChange(index: number) {
    this.selectedTabIndex = index;

    if (index === 0) {
      // Reset Add Collection tab
      this.newCollectionName = '';
      this.subCollectionArray = [{ value: '' }];
      this.collectionExists = false;
      this.subCollectionExists = [];
    } else {
      // Reset Add Sub Collection tab
      this.searchTermSubCollections = '';
      // Keep any collection already selected in the main view.
      // If none is selected, do not auto-select — allow the user to search and pick.
      this.newSubCollections = [''];
      this.subCollectionExists = [];
      this.filteredCollections = [...this.collections]; // Keep collections visible
    }
  }

  selectCollection(collection: any) {
    this.selectedSubCollections = [];
    if (this.selectedCollection?.collection_id === collection.collection_id) {
      return;
    }
    this.selectedCollection = collection;
    this.filteredSubCollections = [...this.selectedCollection.sub_collections];
    this.searchTermSubCollections = '';  // Clear the sub-collection search term
    // Hide collection search results in the Add Sub-Collection dialog (dialog-local only)
    this.dialogSearchTerm = '';
    this.filteredCollectionsDialog = [...this.collections];

    console.info("selectedCollection", this.selectedCollection);
    console.info("filteredSubCollections", this.filteredSubCollections);
    this.selectedCollection.sub_collections.forEach((sub:any) => {
      sub.isSelected = false;
    });
    this.isChecked = true;
    this.isSubChecked = false;
    this.createProjectService.setSelectedCollection(this.selectedCollection);
    this.createProjectService.setIsChecked(this.isChecked); // Store isChecked state
    this.createProjectService.setIsSubChecked(this.isSubChecked); // Store isSubChecked state
    this.checkButtonState();
  }


  toggleSubCollectionSelection(sub: any) {
    console.info("selectedsub", sub);
    sub.isSelected = !sub.isSelected;
    this.selectedSubCollections = this.filteredSubCollections.filter(sub => sub.isSelected);
    this.isSubChecked = true; // Set to true when user selects a sub-collection
    this.createProjectService.setIsSubChecked(this.isSubChecked); // Store isSubChecked state
    this.checkButtonState();
    this.createProjectService.setSelectedSubCollection(this.selectedSubCollections);
  }

  checkButtonState() {
    if (this.selectedCollection.sub_collections.length === 0) {
      const payload = {
        data: {
          collectionId: this.selectedCollection.collection_id,
          collectionName: this.selectedCollection.collection_name,
          subCollectionIds: [],
          subCollectionsName: [],
          createdBy: this.userName
        },
        isEnabled: true
      };
      this.isButtonEnabled.emit(payload);
      return;
    }
    let isEnabled = false;
    console.info(this.selectedCollection);
    if (this.selectedCollection !== null) {
      // Check if there are subCollections and selectedSubCollections are not empty
      if (this.selectedCollection?.sub_collections?.length > 0) {
        if (this.selectedSubCollections.length > 0) {
          isEnabled = true;
        }
      }
    }
    const payload = {
      data: {
        collectionId: this.selectedCollection.collection_id,
        collectionName: this.selectedCollection.collection_name,
        subCollectionIds: this.selectedSubCollections.map(a => a.sub_collection_id),
        subCollectionsName: this.selectedSubCollections.map(a => a.sub_collection_name),
        createdBy: this.userName
      }, isEnabled
    }
    console.info(":::payload", payload);
    this.isButtonEnabled.emit(payload);
  }

  toggleSort() {
    if (this.sortDirection === '') {
      this.sortDirection = 'asc';
      this.filteredCollections.sort((a, b) => a.collection_name.localeCompare(b.collection_name));
    } else if (this.sortDirection === 'asc') {
      this.sortDirection = 'desc';
      this.filteredCollections.sort((a, b) => b.collection_name.localeCompare(a.collection_name));
    } else {
      this.sortDirection = '';
      this.filteredCollections = [...this.collections];
    }
  }

  toggleSortSubCollection() {
    console.info("clicked")
    if (this.sortDirectionSubCollection === '') {
      this.sortDirectionSubCollection = 'asc';
      this.filteredSubCollections.sort((a, b) => a.sub_collection_name.localeCompare(b.sub_collection_name));
    } else if (this.sortDirectionSubCollection === 'asc') {
      this.sortDirectionSubCollection = 'desc';
      this.filteredSubCollections.sort((a, b) => b.sub_collection_name.localeCompare(a.sub_collection_name));
    } else {
      this.sortDirectionSubCollection = '';
      this.filteredSubCollections = [...this.selectedCollection.sub_collections];
    }
  }

  addNewCollection() {
    const newCollectionName = prompt('Enter new collection name:');
    if (newCollectionName?.trim()) {
      this.collections.push({ collection_name: newCollectionName.trim(), sub_collections: [] });
      this.filterCollections();
      // keep dialog list in sync if the dialog is open
      this.filteredCollectionsDialog = [...this.collections];
    }
  }

  exportCollections() {
    const exportData = this.collections.map(c => ({
      Collection: c.collection_name,
      SubCollections: c.sub_collections.length
        ? c.sub_collections.map((sub: any) => sub.sub_collection_name).join('\n') // Join sub_collection_name with \n for new lines
        : ''
    }));

    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet('Collections');

    // Define columns
    worksheet.columns = [
      { header: 'Collection', key: 'Collection', width: 30 },
      { header: 'SubCollections', key: 'SubCollections', width: 50 }
    ];

    // Add rows to the worksheet
    exportData.forEach((row, _index) => {
      worksheet.addRow(row);
    });

    // Dynamically adjust column widths based on the content
    exportData.forEach(row => {
      Object.keys(row).forEach(key => {
        const value = (row as Record<string, any>)[key].toString();
        const column = worksheet.getColumn(key);
        column.width = Math.max(column.width ?? 0, value.length + 2);  // Add padding
      });
    });

    // Enable text wrapping for the 'SubCollections' column (index 1)
    const subCollectionsColumn = worksheet.getColumn('SubCollections');
    subCollectionsColumn.alignment = { wrapText: true };

    // Adjust row height based on the content of 'SubCollections' column
    exportData.forEach((row, rowIndex) => {
      const subCollectionText = row.SubCollections;

      // Count the number of lines in the text (based on '\n')
      const numLines = subCollectionText.split('\n').length;

      // Calculate the height based on the number of lines (e.g., 20px per line)
      const rowHeight = 20 * numLines; // You can adjust the multiplier (e.g., 20) to fit your content

      worksheet.getRow(rowIndex + 2).height = rowHeight;  // Adjust row height (rowIndex + 2 because the first row is headers)
    });

    // Write to a file
    workbook.xlsx.writeBuffer().then((buffer: ArrayBuffer) => {
      const blob = new Blob([buffer], { type: 'application/octet-stream' });
      const link = document.createElement('a');
      link.href = URL.createObjectURL(blob);
      link.download = 'collections.xlsx';
      link.click();
    });
  }

  resetForm() {
    // Clear form state
    this.newCollectionName = '';
    this.newSubCollections = [''];
    this.subCollectionArray = [{ value: '' }];
    this.selectedCollection = null;
    this.isFormValid = false;

    // Clear errors & banners
    this.collectionExists = false;
    this.subCollectionExists = [];

    // 🔹 IMPORTANT: Clear search and show ALL collections again (preserve main search semantics)
    this.searchTermCollections = '';
    this.dialogSearchTerm = '';
    if (Array.isArray(this.collections)) {
      this.filteredCollections = [...this.collections];
      this.filteredCollectionsDialog = [...this.collections];
    } else {
      this.filteredCollections = [];
      this.filteredCollectionsDialog = [];
    }
    // If you also maintain filtered sub-collections:
    this.filteredSubCollections = [];
    this.showAddModal = false;
  }

  openDialog() {
    this.selectedTabIndex = 0;
    this.newCollectionName = '';
    this.dialogSearchTerm = '';
    this.filteredCollectionsDialog = [...this.collections];
    this.isFormValid = false;
    this.newSubCollections = [''];
    this.subCollectionArray = [{ value: '' }];
    this.collectionExists = false;
    this.subCollectionExists = [];
    this.showAddModal = true;
  }

  cancelDialog() {
    this.showAddModal = false;
    this.newCollectionName = '';
    this.dialogSearchTerm = '';
    this.filteredCollectionsDialog = [...this.collections];
    this.isFormValid = false;
    this.newSubCollections = [''];
    this.subCollectionArray = [{ value: '' }];
  }


  trackByIndex(index: number): number {
    return index;
  }

  addSubCollectionField() {
    this.subCollectionArray.push({ value: '' });
  }

  removeSubCollectionField(index: number) {
    this.subCollectionArray.splice(index, 1);
  }

  removeNewSubCollectionField(index: number) {
    this.newSubCollections.splice(index, 1);
  }


  addNewSubCollectionField() {
    this.newSubCollections.push('');
  }

  addSubCollectionFieldExisting() {
    this.selectedSubCollections.push('');
  }

  removeExistingSubCollectionField(index: number) {
    this.selectedSubCollections.splice(index, 1);
  }

  validateForm() {
    if (this.selectedTabIndex === 0) {
      this.isFormValid = this.newCollectionName.trim() !== '';
    } else if (this.selectedTabIndex === 1) {
      const hasSelectedCollection = this.selectedCollection !== null;
      const hasNewSubCollection = this.newSubCollections.some(sub => sub.trim() !== '');
      this.isFormValid = hasSelectedCollection && hasNewSubCollection;
    }
  }

  toggleFavorite(collection: any) {
    const body = {
      collectionId: collection.collection_id,
      updatedBy: this.workDayId
    };

    this.createProjectService.updateFavoriteCollection(body).subscribe({
      next: () => {
        collection.isFavorite = !collection.isFavorite;

        this.collections = this.collections.filter(
          c => c.collection_id !== collection.collection_id
        );

        if (collection.isFavorite) {
          this.collections.unshift(collection);
        } else {
          this.collections.push(collection);
        }
        this.filteredCollections = this.filteredCollections.filter(
          c => c.collection_id !== collection.collection_id
        );

        if (collection.isFavorite) {
          this.filteredCollections.unshift(collection);
        } else {
          this.filteredCollections.push(collection);
        }
        this.filteredCollectionsDialog = [...this.collections];
      },
      error: (error) => {
        console.trace('Error updating favorite status:', error);
      }
    });
  }



}